import { useCallback, useEffect, useState } from 'react'
import {
  Backdrop,
  CircularProgress,
  Grid,
  makeStyles,
  Divider,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@material-ui/core'
import { getNonConformity } from '../../api/nonConformityIncidences.service'
import SaveOrCancelButtons from '../../components/saveOrCancelButtons'
import { formatDate } from '../../common/utils'
import AcceptNonConformity from './AcceptNoConformity'
import { DialogTitle } from '../../components/DialogTitle'
import ResourceList from '../../components/Resources/ResourceList'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  title: {
    justifySelf: 'end',
    margin: '-5px 15px 20px 5px'
  }
}))

const NonConformityDetail = (props) => {
  const classes = useStyles()

  const hncCode = props.hncCode
  const handleClose = props.onClose

  const [loading, setLoading] = useState(false)
  const [stateForm, setStateForm] = useState({})
  const [isModalAcceptOpen, setIsModalAcceptOpen] = useState(false)

  const getData = useCallback(() => {
    setLoading(true)
    getNonConformity(hncCode)
      .then((result) => {
        setStateForm(result.data)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [hncCode])

  useEffect(() => {
    if (hncCode !== undefined && hncCode !== null) {
      getData()
    }
  }, [hncCode, getData])

  const textEmpty = (text) => {
    if (text === undefined || text === null || text === '') {
      return '--'
    }
    if (typeof text == 'boolean') {
      return text ? 'Sí' : 'No'
    }
    return text
  }

  const Title = (_) => <h2>Incidencia de no conformidad: {hncCode}</h2>

  return (
    <div>
      <Grid container direction="column">
        <DialogTitle title={<Title />} />
        <Grid item>
          <Grid container direction="row" spacing={2}>
            <Grid item xs={12} md={6} lg={4}>
              <Typography color="primary" variant="body1">
                Fecha de la incidencia
              </Typography>
              <Typography variant="body1">
                {textEmpty(formatDate(stateForm.creationDate))}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={8}>
              <Typography color="primary" variant="body1">
                Cód. incidencia
              </Typography>
              <Typography variant="body1">{textEmpty(stateForm.incidenceCode)}</Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Typography color="primary" variant="body1">
                Cód. producto
              </Typography>
              <Typography variant="body1">{textEmpty(stateForm.articleCode)}</Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={8}>
              <Typography color="primary" variant="body1">
                Producto
              </Typography>
              <Typography variant="body1">{textEmpty(stateForm.articleDescription)}</Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Typography color="primary" variant="body1">
                Estado
              </Typography>
              <Typography variant="body1">{textEmpty(stateForm.state)}</Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Typography color="primary" variant="body1">
                Almacén
              </Typography>
              <Typography variant="body1">{textEmpty(stateForm.storage)}</Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Typography color="primary" variant="body1">
                Tratamiento
              </Typography>
              <Typography variant="body1">{textEmpty(stateForm.treatment)}</Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Typography color="primary" variant="body1">
                Número de cargo
              </Typography>
              <Typography variant="body1">{textEmpty(stateForm.position)}</Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Typography color="primary" variant="body1">
                Destrucción
              </Typography>
              <Typography variant="body1">
                {textEmpty(
                  stateForm.isDestruction ||
                    (stateForm.treatment && stateForm.treatment.startsWith('DESTRU'))
                )}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <Typography color="primary" variant="body1">
                Devolución
              </Typography>
              <Typography variant="body1">
                {textEmpty(
                  stateForm.isDevolution ||
                    (stateForm.treatment && stateForm.treatment.startsWith('DEVOLR'))
                )}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography color="primary" variant="body1">
                Razón
              </Typography>
              <Typography variant="body1">{textEmpty(stateForm.reason)}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography color="primary" variant="body1">
                Descripción
              </Typography>
              <Typography variant="body1">{textEmpty(stateForm.description)}</Typography>
            </Grid>
          </Grid>
          <Grid container direction="row" spacing={2} className="mt-3">
            <Grid item xs={12}>
              <Typography color="primary" variant="body1" className="text-uppercase">
                Detalle:
              </Typography>
              <Divider className="mb-3" />
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12}>
                  <TableContainer component={Paper}>
                    <Table size="small" sx={{ minWidth: 300 }}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="center"
                            width={'110px'}
                            className="font-weight-bold badge-secondary"
                          >
                            Alcance
                          </TableCell>
                          <TableCell
                            align="center"
                            width={'110px'}
                            className="font-weight-bold badge-secondary"
                          >
                            Tipo Detalle
                          </TableCell>
                          <TableCell
                            align="center"
                            width={'200px'}
                            className="font-weight-bold badge-secondary"
                          >
                            Detalle
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {stateForm.details &&
                          stateForm.details.map((detail, key) => {
                            return (
                              <TableRow
                                key={`non-conformity-detail-${key}`}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                              >
                                <TableCell>{detail.scope}</TableCell>
                                <TableCell>{detail.detailType}</TableCell>
                                <TableCell>
                                  <ul className="pl-1 mb-0">
                                    {detail.data.map((data, keyData) => {
                                      return (
                                        <li key={`data-detail-${keyData}`}>
                                          <strong>{data[0]}: </strong> {data[1]}
                                        </li>
                                      )
                                    })}
                                  </ul>
                                </TableCell>
                              </TableRow>
                            )
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container direction="row" spacing={2}>
            <Grid item xs={12} className="pb-0">
              <Typography color="primary" variant="body1">
                Adjuntos
              </Typography>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <ResourceList resources={stateForm.documents} />
            </Grid>
          </Grid>

          {handleClose !== undefined && (
            <SaveOrCancelButtons
              onSave={
                stateForm.state &&
                !stateForm.state.includes('Cerrada') &&
                stateForm.isDestruction === false &&
                stateForm.isDevolution === false
                  ? () => setIsModalAcceptOpen(true)
                  : undefined
              }
              saveLabel="Aceptar Incidencia"
              onCancel={handleClose}
              cancelLabel="Cerrar"
              loading={loading}
            />
          )}

          <AcceptNonConformity
            open={isModalAcceptOpen}
            incidenceCode={hncCode}
            onCancel={() => setIsModalAcceptOpen(false)}
            onSave={
              handleClose
                ? handleClose
                : () => {
                    return
                  }
            }
          />
        </Grid>
      </Grid>
      <Backdrop className={classes.backdrop} open={loading} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

export default NonConformityDetail
